//导入依赖
import Vue from 'vue'
import VueRouter from 'vue-router'

//引入组件模板(定义路由组件)
//列表页路由
// const Index = () => import ('@/components/index');
// const Knowledge = () => import ('@/components/content/knowledge/list');
// import NotFoundComponent from '@/components/common/notFoundComponent';
// import Search from '@/components/search';
// import Activity from '@/components/content/activity/list';
// import Industry from '@/components/content/industry/list';
// import Knowledge from '@/components/content/knowledge/list';
// import RecruitInner from '@/components/content/recruit/inner/list';
// import RecruitOuter from '@/components/content/recruit/outer/list';

// 详情页路由
// import actDetail from '@/components/content/activity/detail';
// import innerDetail from '@/components/content/recruit/inner/detail';
// import outerDetail from '@/components/content/recruit/outer/detail';
// import knowDetail from '@/components/content/knowledge/detail';
// import indusDetail from '@/components/content/industry/detail';

//将路由引入vue中
Vue.use(VueRouter)

//创建router实例，配置路由(运用路由懒加载模式)
const router =  new VueRouter(
  {
  mode: 'history',
  routes: [
    /**404页面**/
    {
      path: '*',
      name:'Error',
      redirect: '/error/404',
    },
    {
      path: '/error/404',
      name:'Error',
      component: resolve => require(['@/components/common/notFoundComponent'], resolve),
    },
    /**已下架、已删除**/
    {
      path: '/empty',
      name:'Empty',
      component: resolve => require(['@/components/common/detail/empty'], resolve),
    },
    /**默认路由**/
    {
      path: '/',
      redirect: '/recruit/inner/list',
    },
    /**首页**/
    {
      path: '/index',
      name: 'Index',
      // component: Index,
      component: resolve => require(['@/components/index'], resolve),
      meta: {
        title: '面包求职－做个学院，一起烘焙面包。精选干货，内部推荐，行业招聘，行业动态，面包新闻。'
      },
    },
    /**搜索页面**/
    {
      path: '/search',
      name: 'Search',
      // component: Search,
      component: resolve => require(['@/components/search'], resolve),
      meta: {
        title: '面包求职－做个学院，一起烘焙面包。精选干货，内部推荐，行业招聘，行业动态，面包新闻。'
      },
    },
    /**干货页面**/
    {
      path: '/knowledge/list',
      name: 'Knowledge',
      // component: Knowledge,
      component: resolve => require(['@/components/content/knowledge/list'], resolve),
      meta: {
        title: '精选干货，深度剖析全行业现状',
      },
    },
    {
      path: '/knowledge/detail/:id',
      name: 'KnowledgeDetail',
      // component: knowDetail
      component: resolve => require(['@/components/content/knowledge/detail'], resolve),
    },
    /**活动页面**/
    {
      path: '/activity/list',
      name: 'Activity',
      // component: Activity,
      component: resolve => require(['@/components/content/activity/list'], resolve),
      meta: {
        title: '必听讲座，超大礼包，求职路上轻松开挂'
      },
    },
    {
      path: '/activity/detail/:id',
      name: 'ActivityDetail',
      // component: actDetail
      component: resolve => require(['@/components/content/activity/detail'], resolve),
    },
    /**内推页面**/
    {
      path: '/recruit/inner/list',
      name: 'RecruitInner',
      // component: RecruitInner,
      component: resolve => require(['@/components/content/recruit/inner/list'], resolve),
      meta: {
        title: '海量内推，助力你的名企Offer梦'
      },
    },
    {
      path: '/recruit/inner/detail/:id',
      name: 'RecruitInnerDetail',
      // component: innerDetail
      component: resolve => require(['@/components/content/recruit/inner/detail'], resolve),
    },
    /**招聘页面**/
    {
      path: '/recruit/outer/list',
      name: 'RecruitOuter',
      // component: RecruitOuter,
      component: resolve => require(['@/components/content/recruit/outer/list'], resolve),
      meta: {
        title: '包罗万象，无限拓宽你的求职道路'
      },
    },
    {
      path: '/recruit/outer/detail/:id',
      name: 'RecruitOuterDetail',
      // component: outerDetail
      component: resolve => require(['@/components/content/recruit/outer/detail'], resolve),
    },
    /**新闻页面**/
    {
      path: '/industry/list',
      name: 'Industry',
      // component: Industry,
      component: resolve => require(['@/components/content/industry/list'], resolve),
      meta: {
        title: '面包资讯，新鲜出炉的行业深度报道'
      },
    },
    {
      path: '/industry/detail/:id',
      name: 'IndustryDetail',
      // component: indusDetail
      component: resolve => require(['@/components/content/industry/detail'], resolve),
    },
  ]
}
);
export default router;

router.beforeEach((to, from, next) => {
  next()
})



// WEBPACK FOOTER //
// ./src/router/index.js